import { render, staticRenderFns } from "./WhyTermsPage.vue?vue&type=template&id=c8d2fc78&scoped=true"
import script from "./WhyTermsPage.vue?vue&type=script&lang=js"
export * from "./WhyTermsPage.vue?vue&type=script&lang=js"
import style0 from "./WhyTermsPage.vue?vue&type=style&index=0&id=c8d2fc78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d2fc78",
  null
  
)

export default component.exports